import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";

import { FramerTooltip } from "../../tooltips";
import { TopCalendarArrowsStyled } from "./top-calendar.styled";

interface ITopCalendarArrows {
  navigatePrev: () => void;
  navigateNext: () => void;
}

export const TopCalendarArrows: FC<ITopCalendarArrows> = ({
  navigatePrev,
  navigateNext,
}) => {
  const { t } = useTranslation();
  return (
    <FramerTooltip
      content={t("general.DAY_BROWSING")}
      placement={PopoverPlacement.bottom}
    >
      <TopCalendarArrowsStyled>
        <SVG_MUI.CalendarOutLeft3SVG
          data-e2e="svg-arrow-left"
          className="rtl_rotate"
          onClick={() => navigatePrev()}
        />
        <SVG_MUI.CalendarOutRight3SVG
          data-e2e="svg-arrow-right"
          className="rtl_rotate"
          onClick={() => navigateNext()}
        />
      </TopCalendarArrowsStyled>
    </FramerTooltip>
  );
};
